import { z } from 'zod';
import { optionalStringArray } from '../_shared/coerce.js';
export const statisticsQuerySchema = z.object({
    activites: optionalStringArray(),
    classes: optionalStringArray(),
    dateRangeType: z.enum(['year', 'custom']).optional(),
    endDate: z.string().optional(), // Format: DD/MM/YYYY
    fournisseurs: optionalStringArray(),
    locationType: z.enum(['city', 'country', 'zone']).optional(),
    locationValue: optionalStringArray(),
    montantTtcMax: z.coerce.number().optional(),
    montantTtcMin: z.coerce.number().optional(),
    startDate: z.string().optional(), // Format: DD/MM/YYYY
    year: z.coerce.number().int().min(2000).max(2100).optional(),
});
